// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import Icon_google from '../../img/icons/24/color/google.svg';
import {perr} from 'hola_pub_util';
import Icon_trustpilot from '../../../../toolip/pub/img/trustpilot_micro.svg';
import Icon_github from '../../img/icons/github.svg';
import Icon_so from '../../img/icons/stack_overflow.svg';
import Icon_reddit from '../../img/icons/reddit.svg';
import Icon_dev from '../../img/icons/dev.svg';
import Icon_discord from '../../img/icons/discord.svg';
import Svg_bg_left from '../../img/homepage/hero_left.svg';
import Svg_bg_right from '../../img/homepage/hero_right.svg';
import {Button} from '../../lib/button';
import {use_login} from '../navbar/use_login';
import {Uptime} from './uptime';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import styles from './hero.module.less';
import anim_styles from '../../../../toolip/pub/ui/animation.module.less';

export const Hero = ()=>{
    const {theme} = useContext(Settings_context);
    const {on_login} = use_login(true, '/dashboard');
    const {user, show_free_zone_promo} = use_app_context();
    const cta_text = show_free_zone_promo ? 'Try now for free' : 'Try now';
    return <div className={styles.hero_wrapper}>
      <div className={styles.hero}>
        <div className={styles.hero_bg}>
          <Svg_bg_left className={styles.bg_left}/>
          <Svg_bg_right className={styles.bg_right}/>
          <div className={styles.bg_center}/>
        </div>
        <div className={cn(theme.container, styles.container)}>
          <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
            <Uptime/>
          </div>
          <div className={styles.hero_text_wrapper}>
            <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
              Premium Proxies for Just $0.96/GB</h1>
            <div className={cn(styles.hero_cta, anim_styles.hero_showup_3)}>
              <Button caption={<>{cta_text} <Icon_arrow_right/></>}
                size={'l'} to={'/pricing'}
                on_click={()=>{
                  perr({id: 'oculus_homepage_hero_cta_click'});
                }}
              />
              {!user && <Button
                caption={<><Icon_google/> Sign in with Google</>}
                size={'l'} color={'social'}
                on_click={ev=>{
                  on_login(ev);
                  perr({id: 'oculus_homepage_signin_click'});
                }}
              />}
            </div>
            {show_free_zone_promo && <p className={cn(theme.p12,
              theme.med, styles.hero_cta_text,
              anim_styles.hero_showup_3)}>
              * No credit card needed. Free plan available.
            </p>}
            <a href="https://www.trustpilot.com/review/oculusproxies.com"
              target="_blank" rel="noopener noreferrer"
              className={styles.trustpilot}>
              <Icon_trustpilot/>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.hero_socials}>
        <p className={cn(theme.p14, theme.med)}>Thousands of developers
          scrape daily with Oculus proxies:</p>
        <div className={styles.icons}>
          <Icon_github/>
          <Icon_so/>
          <Icon_reddit/>
          <Icon_dev/>
          <Icon_discord/>
        </div>
      </div>
    </div>;
};
